export const RECIPE_MODAL_SHOWN = 'recipeShown';
export const COOKIE_PRIVACY = '33ntft_cmapi_cookie_privacy';
export const COOKIE_CONSENT_ENABLED = 'permit_1|2|3|4';

// ONETRUST
export const NO_PURCHASE = 'NO_PURCHASE';

// A/B
export const SPLIT_PERCENTAGE = 0.5;
